import { useState } from "react";
import { useAuthContext } from './useAuthContext';
import Cookies from 'js-cookie';

export const useLogin = () => {
    const [err, setError] = useState(null)

    const [isLoading, setIsLoading] = useState(null)
    const { dispatch } = useAuthContext();



    const login = async (email, password) => {
        setIsLoading(true)
        setError(null)

        const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/user/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json'},
            body: JSON.stringify({ email, password }),
            
            credentials:'include',
           
        })
        const json = await response.json()

        if (!response.ok) {
            setIsLoading(false)
            setError(json.error)
        }
        if (response.ok) {
            //save the user to localstorage
            // localStorage.setItem('user', JSON.stringify(json))
        //    localStorage.setItem('customerID',json.stripeCustomerId)
   

         
            const user = Cookies.get('token')
       
//    const user = json.token
//    Cookies.set("token",user)
      
            // setTimeout(() => {
            //     Cookies.remove('user')
            //     dispatch({ type: "LOGOUT" });
            // }, 360000)
            //update the auth context
            dispatch({ type: 'LOGIN', payload: user })


            setIsLoading(false)

        }
    }

    return { login, isLoading, err }
}

